import React, { ReactNode } from 'react';
import { EmptyState, TextButton } from '@wix/design-system';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { Refresh } from '@wix/wix-ui-icons-common';

export interface LoadingErrorStateProps {
  dataHook?: string;
  onRetry: () => void;
  image?: ReactNode;
  title?: string;
  subtitle?: string;
  retryText?: string;
}

export function LoadingErrorState(props: LoadingErrorStateProps) {
  const { dataHook, onRetry, title, subtitle, retryText, ...rest } = props;
  const { translate: t } = useWixPatternsContainer();

  return (
    <EmptyState
      theme="page-no-border"
      dataHook={dataHook}
      title={
        title ??
        t('cairo.technical.error.title', {
          defaultValue: 'We couldn’t load your items',
        })
      }
      subtitle={
        subtitle ??
        t('cairo.technical.error.text', {
          defaultValue:
            'There was a technical problem on our end. Refresh the page and try again in a moment.',
        })
      }
      {...rest}
    >
      <TextButton
        onClick={onRetry}
        prefixIcon={<Refresh />}
        dataHook="retry-button"
      >
        {retryText ??
          t('cairo.error.tryAgain.cta', {
            defaultValue: 'Try Again',
          })}
      </TextButton>
    </EmptyState>
  );
}
